import { createFileRoute } from "@tanstack/react-router";

const ClientEditRoute = (): null => null;

export const Route = createFileRoute("/_app/settings/clients/$id/")({
	component: ClientEditRoute,
});
